<div class=" " *ngIf="showRequest"  [class.read-only-content]="isReadOnly" >
  <h2 class="sectionTitle" *ngIf="!isReadOnly">
    {{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.FIBBERGLASS_REQUEST' | translate }}</h2>


      <!--request Details summary-->
      <app-request-details *ngIf="RequestId" [baseRequest]="baseRequestDTO"></app-request-details>
      <!--request -->

  <form [formGroup]="fibberglassRequestForm">
    <div>

      <div class="bs-callout bs-callout-info" *ngIf="Validate.UserRequiredModifications.value != ''">
        <h4>{{ 'FRONT_USER.ADMIN_DECISION_FORM.USER_REQUIRED_MODIFICATIONS' | translate }}</h4>
        <p id="UserRequiredModifications" name="UserRequiredModifications" disabled="disabled">
          {{ Validate.UserRequiredModifications.value }} </p>
      </div>

      <div class="">
        <div class="fiber-side-info pull-right" *ngIf="Validate.ServiceId.value != 'undefined'">
          <div class="service-info" *ngIf="Validate.ServiceId.value != 'undefined'">
            <div class="FiberServiceImg">
              <img id="ServiceImage" [src]="imagePath" />
            </div>

            <div id="MainSpecificationDiv" *ngIf="Validate.BoatTypeId.value != 'undefined'">
              <label>{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.MAIN_SPECIFICATION' | translate }}</label>
              <div class="specification-details">
                <div *ngFor="let item of mainSpecificationsJson">
                  <label>{{item.key}}:</label>
                  <label>{{item.value}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-container" [class.full-width]="Validate.ServiceId.value != 'undefined'">
          <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>

          <div class="form-group">
            <label
              for="FibberglassServiceSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.SERVICE' | translate }}</label>
            <span class="red"> *</span>
            <select id="FibberglassServiceSelect" name="FibberglassServiceSelect" class="form-control"
              formControlName="ServiceId" (change)="onServiceChange($event.target.value)">
              <option [value]="undefined" selected>
                {{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_SERVICE' | translate }}
              </option>
              <ng-container *ngFor="let Service of Services">
                <option *ngIf="displayedLang==Languages.English" [value]="Service.Id">{{ Service.NameEN }}</option>
                <option *ngIf="displayedLang==Languages.Arabic" [value]="Service.Id">{{ Service.NameAR }}</option>
              </ng-container>
            </select>
            <div *ngIf="(submitted|| Validate.ServiceId?.touched) && (Validate.ServiceId?.value == 'undefined'|| Validate.ServiceId?.errors)" class="red">
              <div *ngIf="Validate.ServiceId?.value == 'undefined'">
                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}
              </div>
            </div>
          </div>

          <div *ngIf="Validate.ServiceId.value == Constants.MakeLaunch" class="form-group">
            <label for="BoatTypeSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.BOAT_TYPE' | translate }}</label>
            <select id="BoatTypeSelect" name="BoatTypeSelect" class="form-control" formControlName="BoatTypeId"
              (change)="onBoatTypeChange($event.target.value)">
              <option [value]="undefined" selected>
                {{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_BOAT_TYPE' | translate }}
              </option>
              <ng-container *ngFor="let BoatType of BoatTypes">
                <option *ngIf="displayedLang==Languages.English" [value]="BoatType.Id">{{ BoatType.NameEN }}</option>
                <option *ngIf="displayedLang==Languages.Arabic" [value]="BoatType.Id">{{ BoatType.NameAR }}</option>
              </ng-container>
            </select>
          </div>
          <div class="form-group">
            <label for="FibberglassClientSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CLIENT' | translate }}</label>
            <span class="red"> *</span>
            <select id="FibberglassClientSelect" name="FibberglassClientSelect" class="form-control"
              formControlName="ClientId">
              <option [value]="undefined" selected>{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_CLIENT' | translate }}
              </option>
              <ng-container *ngFor="let Client of Clients">
                <option *ngIf="displayedLang==Languages.English" [value]="Client.Id">{{ Client.NameEN }}</option>
                <option *ngIf="displayedLang==Languages.Arabic" [value]="Client.Id">{{ Client.NameAR }}</option>
              </ng-container>
            </select>
            <div *ngIf="(submitted|| Validate.ClientId?.touched) && (Validate.ClientId?.value == 'undefined'|| Validate.ClientId?.errors)" class="red">
              <div *ngIf="Validate.ClientId?.value == 'undefined'">{{ 'FRONT_USER.This_Field_Is_Required' | translate }}
              </div>
            </div>
          </div>

          <!-- <div class="form-group">
                <button class="btn btn-primary SCAcustomBtn" (click)="SetMe()">SetImage</button>
              </div> -->
        </div>

        <div formGroupName="LaunchBoat">

          <div class="form-container full-width" *ngIf="Validate.BoatTypeId.value != 'undefined'">
            <h4 class="section-title">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.LAUNCH_INFO' | translate }}</h4>

            <!--MAIN SPECIFICATIONS OLD PLACE-->

            <div class="form-group">
              <label for="NoOfBoats">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.NOOFBOATS' | translate }}</label>
              <span class="red"> *</span>
              <input type="text"  class="form-control" id="NoOfBoats" name="NoOfBoats"
                formControlName="NoOfBoatsControl" />
                <div *ngIf="submitted ||(ValidateLaunchBoat.NoOfBoatsControl?.errors&&ValidateLaunchBoat.NoOfBoatsControl?.dirty)" class="red">
                <div *ngIf="ValidateLaunchBoat.NoOfBoatsControl?.errors?.pattern" class="red">{{'FRONT_USER.NUMBER_GREATER_THAN_ZERO_ERROR' | translate}}</div>
                <div *ngIf="ValidateLaunchBoat.NoOfBoatsControl?.errors?.required" class="red">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                </div>
            </div>

            <!-- LANUCH OPTION -->


            <div class="form-group" *ngIf="Validate.BoatTypeId.value != Constants.FalokaLaunch">
              <label>{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.ENGINES' | translate }}</label>
              <span class="red"> *</span>
              <div class="form-custom-inputs">
                <div *ngFor="let engineTypeItem of engineTypesKey;let i='index'" class="custom-Radio">
                  <input [id]="[engineTypeItem]" type="radio" name="WithEngineControl"
                    [value]="engineTypes[engineTypeItem]" formControlName="WithEngineControl"
                    (change)="onEngineChange($event)" />
                  <label
                    [for]="[engineTypeItem]">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.' + engineTypeItem | translate }}</label>
                </div>
              </div>
              <div *ngIf="submitted && ValidateLaunchBoat.WithEngineControl?.errors" class="red">
                <div *ngIf="ValidateLaunchBoat.WithEngineControl?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>
            </div>



            <div class="form-group">
              <label for="Notes">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.NOTES' | translate }}</label>
              <textarea class="form-control" id="Notes" name="Notes" formControlName="NotesControl"
                style="min-height:150px!important"></textarea>
                <div *ngIf="submitted ||(ValidateLaunchBoat.NotesControl?.errors&&ValidateLaunchBoat.NotesControl?.dirty)" class="red">

              <div *ngIf="ValidateLaunchBoat.NotesControl?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_500_ERROR' | translate}}
              </div>
                </div>
            </div>
          </div>

          <div class="form-container clear" formGroupName="LaunchOptions" *ngIf="Constants.FullLaunch.includes(Validate.BoatTypeId.value)">
            <h4 class="section-title">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.LAUNCH_OPTIONS' | translate }}</h4>

            <div class="form-group">
              <label
                for="CommunicationsAndNavigationsSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.COMMUNICATIONS_AND_NAVIGATIONS' | translate }}</label>
              <ng-multiselect-dropdown id="CommunicationsAndNavigationsSelect"
                placeholder="{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_COMMUNICATIONS_AND_NAVIGATIONS' | translate }}"
                [settings]="dropdownSettings" [data]="CommunicationsAndNavigationsOptions" formControlName ="SelectedCommunicationsAndNavigations"
                [disabled]="isReadOnly"></ng-multiselect-dropdown>
            </div>

            <div class="form-group">
              <label
                for="LightingAndLoadsSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.LIGHTING_AND_LOADS' | translate }}</label>
              <ng-multiselect-dropdown id="LightingAndLoadsSelect"
                placeholder="{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_LIGHTING_AND_LOADS' | translate }}"
                [settings]="dropdownSettings" [data]="LightingAndLoadsOptions" formControlName ="SelectedLightingAndLoads"
                 [disabled]="isReadOnly"></ng-multiselect-dropdown>
                <div *ngIf="submitted || (ValidateLaunchOption.SelectedLightingAndLoads?.errors&&ValidateLaunchOption.SelectedLightingAndLoads?.touched)" class="red">
                <div *ngIf="ValidateLaunchOption.SelectedLightingAndLoads?.errors?.required">
                    {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
                </div>

              </div>

            <div class="form-group" *ngIf="Validate.BoatTypeId.value != Constants.FalokaLaunch  && Check380On220Volt">
              <label for="VoltDCs380On220Select">Lighting and loads Extra</label>
              <ng-multiselect-dropdown id="VoltDCs380On220Select" placeholder="{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_VOLTDCS380ON220' | translate }}"
              [settings]="dropdownSettings" [data]="VoltDCs380On220Options" formControlName ="SelectedVoltDCs380On220" 
                [disabled]="isReadOnly"></ng-multiselect-dropdown>
            </div>

            <div class="form-group">
              <label
                for="YachtSafetiesSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.YACHT_SAFETY' | translate }}</label>
              <ng-multiselect-dropdown id="YachtSafetiesSelect"
                placeholder="{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_YACHT_SAFETY' | translate }}"
                [settings]="dropdownSettings" [data]="YachtSafetiesOptions" formControlName ="SelectedYachtSafeties" 
                [disabled]="isReadOnly"></ng-multiselect-dropdown>
            </div>

            <div id="DocumentationsDiv" class="form-group">
              <label>{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.DOCUMENTATION' | translate }}</label>
              <ul class="documentations-lising">
                <li *ngFor="let item of documentationsKeys">
                  <label [for]="[item]">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.' + item | translate }}</label>
                </li>
              </ul>
            </div>

            <div class="form-group">
              <label
                for="ExtraDocumentationsSelect">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.EXTRA_DOCUMENTATION' | translate }}</label>
              <ng-multiselect-dropdown id="ExtraDocumentationsSelect"
                placeholder="{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.CHOOSE_EXTRA_DOCUMENTATION' | translate }}"
                [settings]="dropdownSettings" [data]="ExtraDocumentationsOptions" formControlName ="SelectedExtraDocumentations"
                [disabled]="isReadOnly"></ng-multiselect-dropdown>
            </div>

          </div>
          <div class="form-container" formGroupName="EngineControl"
            *ngIf="ValidateLaunchBoat.WithEngineControl.value == EngineType.WithEngine">
            <h4 class="section-title">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.ENGINE_INFO' | translate }}</h4>

            <div class="form-group">
              <label for="TypeOfEngine">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.TYPE_OF_ENGINE' | translate }}</label>
              <!-- <span class="red"> *</span> -->
              <input type="text" class="form-control" id="TypeOfEngine" name="TypeOfEngine"
                formControlName="TypeOfEngine" />
              <div *ngIf="submitted && ValidateEngine.TypeOfEngine?.errors" class="red">
                <!-- <div *ngIf="ValidateEngine.TypeOfEngine?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div> -->
              </div>
              <div *ngIf="ValidateEngine.TypeOfEngine?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
              </div>
            </div>

            <div class="form-group">
              <label for="SpeedOfBoat">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.SPEED_OF_BOAT' | translate }}</label>
              <span class="red"> *</span>
              <div class="input-group">
                <input type="number" min="1" class="form-control" id="SpeedOfBoat" name="SpeedOfBoat"
                  formControlName="SpeedOfBoat" />
                <span class="input-group-addon">{{ 'FRONT_USER.FIBBERGLASS_REQUEST_FORM.KNOT' | translate}}</span>
              </div>
              <div class="upload-info">
                <span *ngIf="displayedLang==Languages.English">{{ EngineNoteEN }}</span>
                <span *ngIf="displayedLang==Languages.Arabic">{{ EngineNoteAR }}</span>
              </div>
              <div *ngIf="submitted && ValidateEngine.SpeedOfBoat?.errors" class="red">
                <div *ngIf="ValidateEngine.SpeedOfBoat?.errors?.required">
                  {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              </div>
              <div *ngIf="ValidateEngine.SpeedOfBoat?.errors?.max" class="red">
                {{'FRONT_USER.FIBBERGLASS_REQUEST_FORM.MAX_SPEED_BOAT_ERROR' | translate}}
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div [class.full-width]="Validate.ServiceId.value != 'undefined'">
      <div [class.remove-full-width]="Validate.BoatTypeId.value != 'undefined'">
        <app-user-request-details [UserRequestDetailsformGroup]="fibberglassRequestForm" [IsReadOnly]="isReadOnly"
          [SubmitFlag]="submitted" [extrnalData]="userInfo"></app-user-request-details>
      </div>
    </div>

    <div class="form-group" *ngIf="!isReadOnly">
      <label for="TermsAndConditions">
           {{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}
      </label>
      <span class="red"> *</span>
      <div class="custom-checkbox">
        <input type="checkbox" id="TermsAndConditions" name="TermsAndConditions"
          formControlName="TermsAndConditionsControl" />
        <label for="TermsAndConditions">
            <a (click)="goToTermsAndConditions()" target="_blank" >{{ 'FRONT_USER.TERMS_CONDITIONS_ACCEPTANCE' | translate }}
              </a>
            </label>
      </div>
      <div *ngIf="submitted && Validate.TermsAndConditionsControl?.errors" class="red">
        <div *ngIf="Validate.TermsAndConditionsControl?.errors?.required">
          {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
      </div>
    </div>

    <div class="form-group" *ngIf="!isReadOnly">
      <button Confirmation (confirmationClick)="onSubmit()" [disabled]="loading" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate }}</button>
    </div>
  </form>
</div>
<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>


<div *ngIf="RequestId">
  <app-messaging></app-messaging>
</div>
